
export enum UserType { 
    client = 301,
    counsellor = 302,
    organisation = 303
}

